import React, { useContext } from 'react';
import SubmitFields from 'commonComponents/forms/SubmitFields/SubmitFields';
import LoadingSpinner from 'commonComponents/progress/LoadingSpinner/LoadingSpinner';
import { FormContext } from 'hocHelpers/withContactForm';
import CommonFields from '../CommonFields/CommonFields';

import styles from './BaseContactForm.module.scss';
import 'oldAssets/stylesheets/overrides/_recaptcha.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const BaseContactForm = ({
  submit,
  successBlock,
  sitekey,
  user,
  orderOfFields,
  children
}) => {
  const {
    fields,
    url,
    responseOk,
    onSubmit,
    submitting
  } = useContext(FormContext);

  const commonFieldsProps = {
    fields,
    orderOfFields,
    defaltValues: user,
    readOnlyFields: user ? ['email', 'first_name', 'last_name', 'name', 'phone'] : []
  };

  if(submitting) {
    return (
      <div className={ styles.spinner }>
        <LoadingSpinner />
      </div>
    );
  }

  if(responseOk) return successBlock();

  return (
    <form
      className={ styles.BaseContactForm }
      action={ url }
      acceptCharset="UTF-8"
      method="post"
      onSubmit={ onSubmit }
    >
      <CommonFields { ...commonFieldsProps } />
      { children }
      <SubmitFields submit={ submit } sitekey={ sitekey } />
    </form>
  );
};

export default BaseContactForm;
